import { createRoot } from "react-dom/client";
import ReactModal from "react-modal";

const StopLossPopUp = () => {
    return (
        <ReactModal
            isOpen={true}
            ariaHideApp={false}
            shouldFocusAfterRender={false}
            onRequestClose={stopLossPopUp.close}
            style={{
                overlay: {
                    backdropFilter: "blur(2px)",
                    backgroundColor: "#20202099",
                    zIndex: 20
                }
            }}
            className=" w-[90%] md:w-[656px] fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 "
        >
            <div className="flex  flex-col justify-center items-start gap-4 bg-[#FFF] p-8 rounded-2xl">
                <p className="text-[#202020] text-center text-xl font-bold leading-8">Why there is no stoploss?</p>
                <div className="h-px self-stretch bg-[#9D9D9D]"></div>
                <p className="self-stretch text-[#202020] text-base font-medium leading-7">
                    Considering the extreme market volatility, we refrain from giving stoploss for some of the trade
                    ideas to avoid closing of trade idea by a sudden market fluctuation. Be assured, all the trade ideas
                    are posted after a thorough analysis by the research team and have the potential to hit the
                    suggested target. In case the team feels any of these ideas might not be able to hit the suggested
                    target in the given time frame, they close the idea. In this case, you'll receive a timely
                    notification
                </p>
            </div>
        </ReactModal>
    );
};
var root = null;
export const stopLossPopUp = {
    CurrentPopUp: false,
    close: () => {
        root?.unmount();
        stopLossPopUp.CurrentPopUp = false;
    },
    open: (ele, stockPrices, calcNetPriceChange) => {
        root = createRoot(document.getElementById("pop-up-container"));
        if (stopLossPopUp.CurrentPopUp) {
            stopLossPopUp.close();
        }
        root?.render(<StopLossPopUp />);
        stopLossPopUp.CurrentPopUp = true;
    }
};
